import { HttpMethod, RequestOptions, useUserOrKioskRequest } from "../common/lib/fetch";
import { Units } from "../common/units/units";
import { UserFacingMessageCode } from "../common/userFacingMessages/userFacingMessageCodes";

export type GetOutboundStagedOrderResponse = {
  stagedOrder: OutboundStagedOrder,
  stagedPurchaseOrder: OutboundStagedPurchaseOrder,
}

export type OutboundStagedOrder = {
  id: string,
  tareValue: string,
  tareUnit: Units,
  forLoadoutGroup: boolean,
  hasBeenGrossed: boolean,
  requiresGross: boolean,
  errorCode?: UserFacingMessageCode,
  errorParameters?: string[],
}

export type OutboundStagedPurchaseOrder = {
  id: string,
  grossValue?: string,
  grossUnit?: Units,
  hasBeenTared: boolean,
  requiresTare: boolean,
  errorCode?: UserFacingMessageCode,
  errorParameters?: string[],
}

const useGetOutboundStagedOrder = (siteId: string, orderNumber: string, kioskId: string, options: RequestOptions<GetOutboundStagedOrderResponse>) =>
  useUserOrKioskRequest<void, GetOutboundStagedOrderResponse>({
    method: HttpMethod.POST,
    path: `/api/sites/${siteId}/stagedOrders/getOutbound?number=${orderNumber}&kioskId=${kioskId}`
  }, options);

export default useGetOutboundStagedOrder;
